type SentryContext = Record<string, unknown>;

export function init(_options?: SentryContext): void {}

export function replayIntegration(_options?: SentryContext): SentryContext {
	return { name: "sentry-noop-replay" };
}

export function captureException(
	_error: unknown,
	_context?: SentryContext,
): void {}

export function captureMessage(
	_message: string,
	_context?: SentryContext,
): void {}

export function captureRequestError(
	_error: unknown,
	_request?: unknown,
	_context?: SentryContext,
): void {}

export function captureRouterTransitionStart(): void {}

export function withSentryConfig<TConfig>(
	config: TConfig,
	_options?: SentryContext,
): TConfig {
	return config;
}
